import React from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { Modal } from '@components';

const DeclareModal = () => {
    const {
        TrialBalanceStore: {
            declareModalVisible,
            closeDeclareModal,
            updateData,
        },
    } = useStore();

    return (
        <Modal
            show={declareModalVisible}
            onHide={closeDeclareModal}
            title={'確認增加擔保品資料'}
        >
            <form
                onSubmit={async e => {
                    e.preventDefault();
                    closeDeclareModal();
                    updateData('collateralApplyModalVisible', true);
                }}
            >
                <div className="border-0">
                    <h4 className=" title fw-bolder text-center mt-3 lh-base">
                        ※本人聲明非上列擔保品發行公司之內部人
                        <br />
                        (包括董事、監察人、經理人及持有該公司股份超過股份總額百分之十之股東，
                        <br />
                        及其配偶、未成年子女與利用他人名義持有者)
                    </h4>
                    <div className="btn_box d-flex flex-column-reverse flex-sm-row justify-content-center">
                        <button
                            className="btn_check btn rounded-pill text-white"
                            type="submit"
                        >
                            確認
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

export default observer(DeclareModal);
